export const marketplaces = {
  OCC: 'OCC',
  MERCADO_LIVRE: 'Mercado Livre',
  SHOPEE: 'Shopee',
};

export default marketplaces;

export const allowedMarketplaceNames = [
    {
        id: 'OCC',
        name: 'OCC',
    },
    {
        id: 'MERCADO_LIVRE',
        name: 'Mercado Livre',
    },
    {
        id: 'SHOPEE',
        name: 'Shopee',
    },
];
